import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-generalpharmacy',
  templateUrl: './generalpharmacy.component.html',
  styleUrls: ['./generalpharmacy.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class GeneralpharmacyComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema()
    // this.title.setTitle('Elevate Your Pharmacy Business with Medeil Software');

    // // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Streamline pharmacy operations, increase ROI. Automate processes for success. Start with free pharmacy software download.' });

    // this.meta.addTag({ name: 'keywords', content: 'pharmacy management software, pharmacy billing software, medical store software, pharma billing software, medical store billing software' });
    let timezone = '';
    let country = '';
    let state = '';
    let city = '';

    // Check if the platform is a browser
    if (isPlatformBrowser(this.platformId)) {
      timezone = sessionStorage.getItem('timezone');
      country = sessionStorage.getItem('country');
      state = sessionStorage.getItem('state');
      city = sessionStorage.getItem('city');
    }

    // Initialize form with values (considering SSR compatibility)
    this.enquiryForm = this.fb.group({
      leadname: ['', [Validators.required]],
      organizationname: ['', [Validators.required]],
      leadsourceid: ['', []],
      leadsource: ['medeil website', []],
      sourceRef1: ['', []],
      sourceRef2: ['', []],
      description: ['', [Validators.required]],
      primaryphone: ['', [Validators.required]],
      primaryemail: [
        '',
        [
          Validators.required,
          Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')
        ]
      ],
      address1: ['', []],
      address2: ['', []],
      country: [country || '', [], []],  // fallback to empty string if no country in sessionStorage
      countryname1: ['0', []],
      state: [state || '', []],           // fallback to empty string if no state in sessionStorage
      city: [city || '', []],             // fallback to empty string if no city in sessionStorage
      enteredcaptcha: ['', []],
      generatedcaptcha: ['', []],
      phonedialcode: ['', []],
      checkbox: [false, []],
      appfrmtime: ['', []],
      apptotime: ['', []],
      appointmentdate: ['', []],
    });
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Pharmacy Management Software | Streamline Your Pharmacy Operations',
  //     description: 'Discover Medeil\'s pharmacy management software to simplify inventory, billing, and customer management. Boost efficiency and grow your pharmacy business today!',
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/industry/pharmacy-management-software',
  //     keywords: 'Pharmacy management software, pharmacy billing software, pharmacy inventory management, pharmacy POS system, pharmacy software solutions.'
  //   };

  //   this.seoService.setData(seoData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Medeil Pharmacy Management Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Medeil offers an advanced pharmacy management software solution designed to streamline inventory, billing, and customer management for pharmacies worldwide.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     }
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medeil Pharmacy Management Software",
  //     "url": "https://www.medeil.com/industry/pharmacy-management-software",
  //     "description": "Discover Medeil's pharmacy management software to simplify inventory, billing, and customer management. Boost efficiency and grow your pharmacy business today!",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/industry/pharmacy-management-software",
  //       "keywords": "Pharmacy management software, pharmacy billing software, pharmacy inventory management, pharmacy POS system, pharmacy software solutions."
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "Which functionalities are available in your pharmacy software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Clients frequently inquire about the features and functionalities of the Medeil Products software, such as inventory tracking, client administration, reporting tools, integration possibilities, and customer support services."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is it possible to modify your pharmacy software to meet our unique requirements?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Many pharmacies want to know if the software can be customized to meet their specific needs because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "What is the procedure like and how long does it take to integrate your pharmacy software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Since pharmacies may find it difficult to adopt new software, they frequently inquire about the timetable, procedure, and support offered during this period. It's also typical to have questions concerning training, data migration, and continuing support. MEDEIL Standalone is the easiest downloadable software to install, while regarding our pharmacy SaaS apps, it's just a sign-up process to activate your subscription instantly for both the cloud version and mobile app version."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "What are the expenses related to the software for your pharmacy?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Pharmacists prioritize cost while evaluating new software solutions. They could inquire about upfront costs, ongoing membership fees, additional costs for customizations or integrations, and any other unspecified costs. Vanuston offers straightforward and economical pharmacy software deployment, beginning with a free version."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }


  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@PHARMACY_SOFTWARE.SEO_TITLE:Pharmacy Management Software | Streamline Your Pharmacy Operations`,
  //     description: $localize`:@@PHARMACY_SOFTWARE.SEO_DESCRIPTION:Discover Medeil's pharmacy management software to simplify inventory, billing, and customer management. Boost efficiency and grow your pharmacy business today!`,
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/industry/pharmacy-management-software',
  //     keywords: $localize`:@@PHARMACY_SOFTWARE.SEO_KEYWORDS:Pharmacy management software, pharmacy billing software, pharmacy inventory management, pharmacy POS system, pharmacy software solutions.`
  //   };
  //   this.seoService.setData(seoData);
  // }


  setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';

    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');

      let lang = 'en'; // Default
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }

      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }


    const seoData  = {
      title: $localize`:@@PHARMACY_SOFTWARE.SEO_TITLE:Pharmacy Software | Simplify Operations`,
      description: $localize`:@@PHARMACY_SOFTWARE.SEO_DESCRIPTION:Manage inventory, billing, and customers easily with Medeil's pharmacy software. Improve efficiency and grow your business.`,
          image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
          url: 'https://www.medeil.com/industry/pharmacy-management-software',
          keywords: $localize`:@@PHARMACY_SOFTWARE.SEO_KEYWORDS:Pharmacy management software, pharmacy billing software, pharmacy inventory management, pharmacy POS system, pharmacy software solutions.`
        };

    this.title.setTitle(seoData.title);

    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@PHARMACY_SOFTWARE.WEBSITE_NAME:Medeil Pharmacy Management Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@PHARMACY_SOFTWARE.WEBSITE_DESCRIPTION:Medeil offers an advanced pharmacy management software solution designed to streamline inventory, billing, and customer management for pharmacies worldwide.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };
    this.jsonLdService.setData(schemaData);
  }

  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@PHARMACY_SOFTWARE.SCHEMA_NAME:Medeil Pharmacy Management Software`,
      "url": "https://www.medeil.com/en/industry/pharmacy-management-software",
      "description": $localize`:@@PHARMACY_SOFTWARE.SCHEMA_DESCRIPTION:Discover Medeil's pharmacy management software to simplify inventory, billing, and customer management. Boost efficiency and grow your pharmacy business today!`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": $localize`:@@PHARMACY_SOFTWARE.OS:Cloud-based (Web, Windows, macOS, Linux)`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/en/industry/pharmacy-management-software",
        "keywords": $localize`:@@PHARMACY_SOFTWARE.SEO_KEYWORDS:Pharmacy management software, pharmacy billing software, pharmacy inventory management, pharmacy POS system, pharmacy software solutions.`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };
    this.jsonLdService.setData(schemaData);
  }

  setFaqSchemaData() {

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@PHARMACY_SOFTWARE.FAQ_1_Q:Which functionalities are available in your pharmacy software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@PHARMACY_SOFTWARE.FAQ_1_A:Clients frequently inquire about the features and functionalities of the Medeil Products software, such as inventory tracking, client administration, reporting tools, integration possibilities, and customer support services.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@PHARMACY_SOFTWARE.FAQ_2_Q:Is it possible to modify your pharmacy software to meet our unique requirements?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@PHARMACY_SOFTWARE.FAQ_2_A:Many pharmacies want to know if the software can be customized to meet their specific needs because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@PHARMACY_SOFTWARE.FAQ_3_Q:What is the procedure like and how long does it take to integrate your pharmacy software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@PHARMACY_SOFTWARE.FAQ_3_A:Since pharmacies may find it difficult to adopt new software, they frequently inquire about the timetable, procedure, and support offered during this period. It's also typical to have questions concerning training, data migration, and continuing support. MEDEIL Standalone is the easiest downloadable software to install, while regarding our pharmacy SaaS apps, it's just a sign-up process to activate your subscription instantly for both the cloud version and mobile app version.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@PHARMACY_SOFTWARE.FAQ_4_Q:What are the expenses related to the software for your pharmacy?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@PHARMACY_SOFTWARE.FAQ_4_A:Pharmacists prioritize cost while evaluating new software solutions. They could inquire about upfront costs, ongoing membership fees, additional costs for customizations or integrations, and any other unspecified costs. Vanuston offers straightforward and economical pharmacy software deployment, beginning with a free version.`
          }
        }
      ]
    };
    this.addJsonLdToHead(faqSchema);

  }


  addJsonLdToHead(schema: any) {
    if (isPlatformBrowser(this.platformId)) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }
  }

  ngOnInit(): void {
    this.mainservice.generatecaptcha();
    if (isPlatformBrowser(this.platformId)) {
      this.captcha = localStorage.getItem('captcha');
    }
    // this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha() {
    this.mainservice.generatecaptcha();
    // Only attempt to get from localStorage in the browser
    if (isPlatformBrowser(this.platformId)) {
      this.captcha = localStorage.getItem('captcha');
    }
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();

  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();

  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
